import React, { FC, useCallback, useMemo, useEffect } from 'react'

import { makeStyles } from '@mui/styles'
import { Grid, Typography, Theme } from '@mui/material'
import { useHistory, useParams, useLocation } from 'react-router-dom'

import { TabsComponent } from '../../components/Tabs'
import { tabList } from './tabList'
import { routes } from '../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  topWrap: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingTop: theme.spacing(6),
  },
}))

export const Finance: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { tab } = useParams<{ tab: string }>()

  const activeTab = useMemo(() => {
    if (location.pathname.includes('/finance/accounts/')) {
      return 'accounts'
    }
    const currentTab = tabList.find((t) => t.slug === tab)
    return currentTab?.slug || tabList[0].slug
  }, [tab, location.pathname])

  useEffect(() => {
    if (tab !== activeTab && activeTab && !location.pathname.includes('/finance/accounts/')) {
      history.replace(`${routes.FINANCE}/${activeTab}`)
    }
  }, [activeTab, tab, history, location.pathname])

  const handleTabChange = useCallback(
    (key: string) => {
      if (key === 'accounts') {
        history.push(`${routes.FINANCE}/accounts/wallets?page=1`)
      } else {
        history.push(`${routes.FINANCE}/${key}`)
      }
    },
    [history],
  )

  return (
    <>
      <Grid container className={classes.topWrap}>
        <Typography variant="h1">Finance</Typography>
      </Grid>

      <TabsComponent tabList={tabList} activeTab={activeTab} onChangeTab={handleTabChange} />
    </>
  )
}
